import classnames from 'classnames';
import React from 'react';

interface MobileAppQRCodeProps {
	className?: string;
	dataqa?: string;
}

const MobileAppQRCode: React.FC<MobileAppQRCodeProps> = ({
	className,
	dataqa,
}) => {
	return (
		<div
			className={classnames('common-ui-mobile-app-qr-code', className)}
			data-qa={dataqa}
		/>
	);
};

export default MobileAppQRCode;
